import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FollowTheSignsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"follow_the_signs"}/>
}
